import { actions } from "./actions";
import { ActionPayload, ChatState } from "./types";

export function createInitialState(): ChatState {
  return {
    optimisticUserMessage: null,
    isLoading: false,
    error: null,
    sessionId: null,
    draftInput: "",
  };
}

export function chatReducer(
  state: ChatState,
  action: ActionPayload
): ChatState {
  switch (action.type) {
    case actions.ADD_OPTIMISTIC_MESSAGE:
      return {
        ...state,
        optimisticUserMessage: action.payload,
      };

    case actions.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case actions.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case actions.SET_DRAFT_INPUT:
      return {
        ...state,
        draftInput: action.payload,
      };

    case actions.RESET_CHAT:
      return {
        ...state,
        optimisticUserMessage: null,
        isLoading: false,
        error: null,
      };

    case actions.SET_CHAT_SESSION_ID:
      return {
        ...state,
        sessionId: action.payload,
      };

    case actions.RESET_CHAT:
      return createInitialState();

    default:
      return state;
  }
}
